var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgBasicSafe = function SvgBasicSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    d: "M70 71.667v5H60v-5zM40 71.667v5H30v-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.667 73.333V26.667H18.333v46.666h63.334z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.667 68.333V31.667H23.333v36.667h53.334z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    d: "M76.667 36.667h5v10h-5zM76.667 53.333h5v10h-5zM71.667 36.667h5v10h-5zM71.667 53.333h5v10h-5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 44.167,
    width: 11.667,
    height: 11.667,
    rx: 5.833,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.833 47.5v5",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    d: "M48.333 38.333h3.333v3.333h-3.333zM55 38.333h3.333v3.333H55zM61.667 38.333H65v3.333h-3.333zM48.333 45h3.333v3.333h-3.333zM55 45h3.333v3.333H55zM61.667 45H65v3.333h-3.333zM48.333 51.667h3.333V55h-3.333zM48.333 58.333h3.333v3.333h-3.333zM55 51.667h3.333V55H55zM55 58.333h3.333v3.333H55zM61.667 51.667H65V55h-3.333zM61.667 58.333H65v3.333h-3.333z"
  })));
};

export default SvgBasicSafe;